import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PdfObjectFallback } from '../PdfObjectFallback';

interface ReviewPdfViewerProps {
  src: string;
  fileName?: string | null;
}

export function ReviewPdfViewer({ src, fileName }: ReviewPdfViewerProps) {
  return (
    <div className="relative flex h-full w-full flex-col">
      <div className="absolute right-3 top-3 z-10">
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.open(src, '_blank', 'noopener,noreferrer')}
          title={fileName ? `Open ${fileName} in new tab` : 'Open in new tab'}
        >
          <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
          Open in new tab
        </Button>
      </div>
      <PdfObjectFallback url={src} className="h-full w-full" />
    </div>
  );
}
